<template>
	<div class="flex">
		<BaseInput
			ref="BaseInput.city.zipcode"
			:required="required && zipCodeRequired"
			:validation="regex.zipCode"
			class="mr-4 w-1/2"
			:label="$t('zip_code')"
			type="tel"
			@input="zipCodeChanged"
			v-model="value.zipCode"
			maxlength="5"
			:error-message="$t('enter_five_char_zip')"
			:validation-messages="{ matches: $t('enter_five_char_zip') }"
			:disabled="disabled"
			mask="NNNNN"
			@validationComplete="checkValidation('zipcode')"
		/>
		<BaseInput
			ref="BaseInput.city.name"
			class="w-1/2"
			:label="$t('place')"
			:required="required"
			type="text"
			v-model="value.name"
			:disabled="disableCity"
			@validationComplete="checkValidation('city.name')"
		/>
	</div>
</template>
<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import RegexpHelper from '@/mixins/RegexpHelper';
import { LocationsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Validate from '@/mixins/Validate';

export default {
	name: 'CityInput',
	components: { BaseInput },
	mixins: [RegexpHelper, Validate],
	data() {
		return {
			isCityFromApi: false,
		};
	},
	props: {
		value: {},
		disabled: { default: false },
		required: { default: true },
		zipCodeRequired: { default: true },
	},
	computed: {
		getZipCodeLength() {
			return this.value.zipCode?.length;
		},
		disableCity() {
			return this.disabled;
		},
	},
	methods: {
		checkValidation: function() {
			this.$emit('validationComplete');
		},
		setTempValid: function() {
			this.$refs['BaseInput.city.zipcode'].isValid = true;
			this.$refs['BaseInput.city.name'].isValid = true;
		},
		zipCodeChanged: function() {
			if (this.value.zipCode.toString().length === 5) {
				this.getCityToZipCode();
			} else {
				this.value.name = null;
			}
		},
		getCityToZipCode: function() {
			LocationsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.locationsCitiesGet(this.value.zipCode)
				.then(response => {
					this.isCityFromApi = response.data?.id !== undefined;
					this.$emit('input', { ...response.data, isCityFromApi: this.isCityFromApi });
				})
				.catch(error => {
					//set name and id to null to remove city in ui
					this.value.name = null;
					this.value.id = null;
					this.$refs['BaseInput.city.zipcode'].isValid = false;
				});
		},
	},
};
</script>
